module.exports = __webpack_public_path__ + "static/media/58_Marketing_shortcut.0f359951.gif";